import { render, staticRenderFns } from "./EmailVerificationSuccess.vue?vue&type=template&id=21731f09"
import script from "./EmailVerificationSuccess.vue?vue&type=script&lang=js"
export * from "./EmailVerificationSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports